<template>
  <div id="finance-wrap">
    <div class="ss">
      <!-- @tab-click="changeTabsCur" -->
      <el-tabs v-model="tabsCur" @tab-click="handleChangeTabsCur">
        <el-tab-pane
          :label="item.name"
          :name="item.value"
          v-for="(item, index) in tabs"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <div class="finance-tabs" v-if="false">
        <div
          class="item"
          :class="{
            cur: item.value === tabsCur,
          }"
          v-for="(item, index) in tabs"
          :key="index"
          @click="changeTabsCur(item.value)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="table-box">
        <!-- <el-scrollbar> -->
        <table
          class="table-item"
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead class="table-head">
            <tr>
              <th class="head-item">
                <span> 项目 </span>
                <el-button
                  type="primary"
                  @click="changeLevels(99)"
                  size="mini"
                  class="info-btn"
                  v-show="levels === 1"
                >
                  详情
                </el-button>
                <el-button
                  type="primary"
                  @click="changeLevels(1)"
                  size="mini"
                  class="info-btn"
                  v-show="levels === 99"
                >
                  返回
                </el-button>
              </th>
              <th class="head-item">本月预算金额(万元)</th>
              <th class="head-item">本月累计发生额(万元)</th>
              <th class="head-item">预算达成率(%)</th>
              <th class="head-item">上年同期数(万元)</th>
              <th class="head-item">同比增减(变动)</th>
              <th class="head-item">上月数(万元)</th>
              <th class="head-item">环比增减(变动)</th>
            </tr>
          </thead>
        </table>
        <div class="table-body-block">
          <div class="table-body-block-fix">
            <table
              class="table-item"
              width="100%"
              border="0"
              style="background: #1c1839;"
              cellspacing="0"
              cellpadding="0"
            >
              <tbody class="table-body">
                <template v-for="(item, index) in financeData[tabsCur]">
                  <!-- v-if="item.levels <=levels" -->
                  <tr class="table-line" :key="index" v-if="item.levels <= levels">
                    <td class="body-lable">
                      <div class="project" v-html="item.pbusinessName"></div>
                    </td>
                    <td class="body-lable">
                      {{ addCodePercentIcon(item.remarks, item.budgetAmount) }}
                    </td>
                    <td class="body-lable">
                      {{ addCodePercentIcon(item.remarks, item.amount) }}
                    </td>
                    <td class="body-lable">
                      <span>
                        <!-- :class="[
                        judgeIncreaseDecrease(item.finishRatio,item.remarks)
                      ]" -->
                        {{ item.finishRatio }}%
                      </span>
                    </td>
                    <td class="body-lable">
                      {{ addCodePercentIcon(item.remarks, item.rqAmount) }}
                    </td>
                    <td class="body-lable">
                      {{ Math.round((item.amountYear / 10000)) }}(<span
                        :class="[
                          judgeIncreaseDecrease(item.amountYear || 0, item.remarks),
                        ]"
                      >{{ item.amountYRatio.toFixed(1) }}%</span>)
                    </td>
                    <td class="body-lable">
                      {{ addCodePercentIcon(item.remarks, item.lastAmount) }}
                    </td>
                    <td class="body-lable">
                      {{ Math.round((item.amountMonth / 10000)) }}(<span
                        :class="[
                          judgeIncreaseDecrease(item.amountMonth || 0, item.remarks),
                        ]"
                      >{{ item.amountMRatio.toFixed(1) }}%</span>)
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>

        <!-- </el-scrollbar> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Base64 } from 'js-base64'
export default {
  components: {},
  props: {},
  data () {
    return {
      tabsCur: '',
      tabs: [],
      financeData: {},
      levels: 1
    }
  },
  computed: {},
  methods: {
    getRemarkCode (remarksLists = []) {
      let codeList = [
        '008',
        '007',
        '003',
        '004',
        '016',
        '017',
        '018',
        '026',
        '028',
        '032',
        '030'
      ]
      for (let i = 0; i < codeList.length; i++) {
        if (remarksLists.includes(codeList[i])) {
          return true
        }
      }
    },
    judgeIncreaseDecrease (value, remarks = '000') {
      let count = +value
      let className = ''
      if (this.getRemarkCode(remarks.split(','))) {
        className = count >= 0 ? 'green' : 'red'
      } else {
        className = count >= 0 ? 'red' : 'green'
      }
      return className
    },
    getData () {
      this.$service
        .fetch({
          url: '/api/finance/getAllFinanceDept'
        })
        .then((res) => {
          this.tabs = res
          this.tabsCur = res[0].value
        })
      this.$service
        .fetch({
          url: `/api/finance/dashboard?month=${
            JSON.parse(sessionStorage.getItem('toggleDate')).time
          }`
        })
        .then((res) => {
          this.financeData = res.financeBoardVOList
        })
    },
    checkToken (val) {
      let mobile = JSON.parse(val).mobile
      this.$service
        .fetch({
          url: `/api/finance/getFinanceMobileList`
        })
        .then((res) => {
          if (res.includes(mobile)) {
            this.getData()
          } else {
            this.$alert('您无权限访问该页面！', '提示', {
              confirmButtonText: '确定'
            }).then(({ value }) => {
              this.$router.push({ path: `/` })
            })
          }
        })
        .catch(() => {
          this.$router.push({ path: `/` })
        })
    },
    changeLevels (level) {
      this.levels = level
    },
    changeTabsCur (value) {
      this.tabsCur = value
      this.changeLevels(1)
    },
    handleChangeTabsCur () {
      console.log('this.tabsCur: ', this.tabsCur)
      this.changeLevels(1)
    },
    addCodePercentIcon (remarksLists = [], value = '') {
      let codeList = ['006', '007', '030', '031']
      let newValue = Number(value) / 10000
      for (let i = 0; i < codeList.length; i++) {
        if (remarksLists.includes(codeList[i])) {
          let num = +newValue
          return `${num.toFixed(1)}%`
        }
      }
      return Math.round(newValue)
    }
  },
  created () {
    this.getData()
    // let token = window.localStorage.getItem('token')
    // if (token) {
    //   this.checkToken(Base64.decode(token.split('.')[1]))
    // }
  }
}
</script>
<style lang="scss" scoped>
#finance-wrap {
  width: 100%;
  /deep/ .el-tabs__header {
    height: 50px;
    line-height: 50px;
    background: #1c1839;
    border-radius: 10px;
    margin-bottom: 0;
  }
  /deep/ .el-tabs__nav-prev, /deep/.el-tabs__nav-next {
    font-size: 24px;
    line-height: 50px;
  }
  /deep/ .el-tabs__active-bar {
    background-color: transparent;
  }
  /deep/ .el-tabs__item {
    padding: 0 16px;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    color: #fff;
    &.is-active {
      background: #007eff;
    }
  }
  /deep/ .el-tabs__nav-wrap::after {
    background-color: transparent;
  }
  .table-head {
    width: 100%;
    background: #1f1e44;
    height: 40px;
    color: #fff;
    position: sticky;
    top: 0;
    tr {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      .head-item {
        flex: 1;
        border-right: 1px solid #44426e;
        font-size: 14px;
        position: relative;
        height: 2rem;
        line-height: 2rem;
        &:nth-child(1) {
          min-width: calc(25% - 20px);
        }
      }
    }
  }
  .table-body-block {
    width: calc(100% + 1.5rem);
    box-sizing: border-box;
    position: relative;
    .table-body-block-fix {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0rem;
      box-sizing: border-box;
      padding-right: 1.5rem;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 0.75rem;
        height: 0.75rem;
        background-color: #F5F5F5;
        position: absolute;
      }
      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 0.375rem #999;
        border-radius: 0.625rem;
        background-color: #F5F5F5;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 0.625rem;
        box-shadow: inset 0 0 0.375rem #999;
        background-color: #333;
      }
    }
    table {
      width: 100%;
      // left: 0;
      // right: 1.5rem;
      // position: absolute;
      tr {
        display: flex;
        .body-lable {
          flex: 1;
          &:nth-child(1) {
            min-width: calc(25% - 0px);
          }
        }
      }
    }
  }
}
</style>
<style lang="stylus" scoped>
.finance-tabs
  background #1c1839
  line-height 50px
  height 50px
  border-radius 10px
  overflow hidden
  white-space nowrap
  padding-left 12px
  flex-shrink: 0
  .item
    display inline-block
    padding 0 16px
    font-size 14px
    color #fff
    text-align center
    cursor pointer
    vertical-align top
  .cur
    background #007eff
.table-box
  background #1c1839
  border-radius 10px
  margin-top 10px
  text-align center
  // height 1080px
  flex-grow: 1
  &::-webkit-scrollbar
      width: 0.75rem;
      height: 0.75rem;
      background-color: #F5F5F5;
  &::-webkit-scrollbar-track
      box-shadow: inset 0 0 0.375rem #999;
      border-radius: 0.625rem;
      background-color: #F5F5F5;
  &::-webkit-scrollbar-thumb
      border-radius: 0.625rem;
      box-shadow: inset 0 0 0.375rem #999;
      background-color: #333;
  .table-body-block
    width calc(100% + 1rem)
    padding-right 1rem
    box-sizing: border-box
    height: calc(100vh - 190px)
    &::-webkit-scrollbar
      width: 0.75rem;
      height: 0.75rem;
      background-color: #F5F5F5;
    &::-webkit-scrollbar-track
        box-shadow: inset 0 0 0.375rem #999;
        border-radius: 0.625rem;
        background-color: #F5F5F5;
    &::-webkit-scrollbar-thumb
        border-radius: 0.625rem;
        box-shadow: inset 0 0 0.375rem #999;
        background-color: #333;
  .table-head
    background #1f1e44
    height 40px
    color #fff
    position: sticky
    top: 0
    .head-item
      width 11%
      border-right 1px solid #44426e
      font-size 14px
      position relative
      height: 2rem
    .head-item:last-child
      border none 0
    .head-item:first-child
      padding-left 20px
      text-align left
      width calc(25% - 20px)
  .table-line
    height 35px
    line-height 35px
    color rgba(255,255,255,0.6)
    font-size 13px
    .body-lable
      border-right 1px solid #343146
      border-bottom 1px solid #343146
      width :11%
      .project
        padding-left 20px
        text-align left
      .subproject
        padding-left 30px
        text-align left
    .body-lable:first-child
        width: calc(25% - 20px);
    .body-lable:last-child
      border-right none 0
  .table-line:last-child .body-lable
    border-bottom none 0
.table-item
  border-bottom: 1px solid #44426e
#finance-wrap
  //height 100%
  //overflow: hidden
  flex-grow: 1
  >>> .el-scrollbar
        height 100%
        .el-scrollbar__wrap
          overflow-x: hidden

.info-btn
  position: absolute;
  right: 10px;
  top 5px

.ss
  height: 100%
  width calc(100% - 1rem)
  display: flex;
  flex-direction: column;

.body-lable
  .red
    color: red
  .green
    color: green
</style>
